// extracted by mini-css-extract-plugin
module.exports = {"modal_title":"special_conditions__modal_title__mZ48H color__color_brand_base__AW2MU padding__padding_top_large__azgMZ padding__padding_left_large__q9hmW"};